// Config da plataforma externa AuraConect (projeto separado) — reservada para integrações futuras; a Landing Page não redireciona visitantes para cadastro de Cliente/Profissional.
export const AURACONECT_URL = process.env.REACT_APP_AURACONECT_URL;
export const AURACONECT_API_URL = process.env.REACT_APP_AURACONECT_API_URL;
